<template>
  <div class="container">
    <Layout style="height: 100%">
      <Header>
        <Menu mode="horizontal" theme="dark">
          <MenuItem name="1">
            <Icon type="ios-person"></Icon>
            ユーザー
          </MenuItem>
        </Menu>
      </Header>
      <Content :style="{padding: '24px', height: '100%'}">
        <div class="clearfix">
          <Button type="primary" style="float: right;" @click="showCreateUser">
            <Icon type="md-add" />
            ユーザーを追加
          </Button>
        </div>
        <Table :columns="columns" :data="users">
          <template slot-scope="{ row, indedx }" slot="administrable">
            <i-switch v-model="row.administrable" />
          </template>
          <template slot-scope="{ row, indedx }" slot="roles">
            <Button type="text" @click="showEditUserRole(row)">{{ Object.keys(row.roles).length }}件</Button>
          </template>
          <template slot-scope="{ row, index }" slot="password">
            <span v-if="row.password">あり</span>
            <span v-else>なし</span>
          </template>
          <template slot-scope="{ row, index }" slot="actions">
            <Button
              type="info"
              style="margin-right: 10px;"
              @click="showEditProfileUser(row)"
            >編集</Button>
            <Button
              type="success"
              style="margin-right: 10px;"
              @click="showEditUserPassword(row)"
            >パスワードを変更</Button>
            <Button type="error" class="action" @click="deleteUser(row.id)">削除</Button>
          </template>
        </Table>
      </Content>
    </Layout>
    <Modal
      :closable="false"
      v-model="editUserProfileModal.show"
      footer-hide
      >
      <div>
        <Form>
          <FormItem label="名前">
            <Input v-model="editUserProfileModal.data.name" />
          </FormItem>
          <FormItem label="組織">
            <Input v-model="editUserProfileModal.data.organization" />
          </FormItem>
          <FormItem label="部署">
            <Input v-model="editUserProfileModal.data.department" />
          </FormItem>
          <div class="clearfix">
            <Button type="success" @click="updateUserProfile(editUserProfileModal.data)" style="float: right">保存</Button>
          </div>
        </Form>
      </div>
    </Modal>
    <Modal
      :closable="false"
      v-model="editUserPasswordModal.show"
      footer-hide
      >
      <div>
        <Form>
          <FormItem label="パスワード">
            <Input v-model="editUserPasswordModal.data.password" />
          </FormItem>
          <div class="clearfix">
            <Button type="success" @click="updateUserPassword(editUserPasswordModal.data)" style="float: right">保存</Button>
          </div>
        </Form>
      </div>
    </Modal>
    <Modal
      :closable="false"
      v-model="editUserRoleModal.show"
      footer-hide
      >
      <div>
        <h3 style="padding-bottom: 1em">権限一覧</h3>
        <List v-if="Object.keys(editUserRoleModal.data.roles).length > 0">
          <ListItem v-for="i in Object.keys(editUserRoleModal.data.roles)" key="i">
            {{ i }} | {{ editUserRoleModal.data.roles[i] | userRoleType }}
            <a href="#" @click="removeUserRole(editUserRoleModal.data.id, i)" style="padding-left: 1em;">削除</a>
          </ListItem>
        </List>
        <p v-else>なし</p>
        <h3 style="padding: 1em 0;">権限追加</h3>
        <Row>
          <Col span="10">
            <Select
              v-model="editUserRoleModal.data.newChannelId"
              placeholder="チャンネルを選択"
              style="padding-right: 0.5em"
            >
              <Option v-for="channel in channels" key="channel.id" :value="channel.id">
                {{ channel.name }}
              </Option>
            </Select>
          </Col>
          <Col span="10">
            <Select
              v-model="editUserRoleModal.data.newRoleType"
              placeholder="権限を選択"
              style="padding-right: 0.5em"
            >
              <Option value="guest">閲覧</Option>
              <Option value="guest">編集</Option>
              <Option value="guest">管理</Option>
            </Select>
          </Col>
          <Col span="4">
            <Button long type="success" @click="appendUserRole(editUserRoleModal.data.id, editUserRoleModal.data.newChannelId, editUserRoleModal.data.newRoleType)">追加</Button>
          </Col>
        </Row>
      </div>
    </Modal>
    <Modal
      :closable="false"
      v-model="createUserModal.show"
      footer-hide
      >
      <div>
        <Form>
          <FormItem label="ID">
            <Input v-model="createUserModal.data.id" />
          </FormItem>
          <FormItem label="名前">
            <Input v-model="createUserModal.data.name" />
          </FormItem>
          <FormItem label="組織">
            <Input v-model="createUserModal.data.organization" />
          </FormItem>
          <FormItem label="部署">
            <Input v-model="createUserModal.data.department" />
          </FormItem>
          <div class="clearfix">
            <Button type="success" style="float: right" :disabled="!createUserModal.data.id" @click="createUser(createUserModal.data)">保存</Button>
          </div>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      editUserProfileModal: {
        show: false,
        data: {
          id: null,
          name: "",
          organization: "",
          department: "",
        }
      },
      editUserPasswordModal: {
        show: false,
        data: {
          id: null,
          password: ""
        }
      },
      editUserRoleModal: {
        show: false,
        data: {
          id: null,
          roles: {},
          newChannelId: null,
          newRoleType: null
        }
      },
      createUserModal: {
        show: false,
        data: {
          id: null,
          name: "",
          organization: "",
          department: "",
        }
      },
      columns: [
        {'title': 'ID', 'key': 'id', 'width': 120},
        {'title': '名前', 'key': 'name'},
        {'title': '組織', 'key': 'organization'},
        {'title': '部署', 'key': 'department'},
        {'title': 'パスワード', 'slot': 'password'},
        {'title': 'チャンネル', 'slot': 'roles'},
        {'title': '管理権限', 'slot': 'administrable'},
        {'title': ' ', 'slot': 'actions', 'width': 320},
      ]
    }
  },
  methods: {
    ...mapActions([
      'fetchAllUser',
      'fetchAllChannel'
    ]),
    showEditProfileUser(user) {
      this.editUserProfileModal.show = true
      this.editUserProfileModal.data.id = user.id
      this.editUserProfileModal.data.name = user.name
      this.editUserProfileModal.data.organization = user.organization
      this.editUserProfileModal.data.department = user.department
    },
    showEditUserPassword(user) {
      this.editUserPasswordModal.show = true
      this.editUserPasswordModal.data.id = user.id
      this.editUserPasswordModal.data.password = ""
    },
    showEditUserRole(user) {
      this.editUserRoleModal.show = true
      this.editUserRoleModal.data.id = user.id
      this.editUserRoleModal.data.roles = { ...user.roles }
    },
    showCreateUser() {
      this.createUserModal.show = true
    },
    async updateUserProfile({ id, name, organization, department}) {
      await this.$store.dispatch('updateUser', {
        userId: id, userInput: { name, organization, department }
      })
      this.editUserProfileModal.show = false
    },
    async updateUserPassword({ id, password }) {
      await this.$store.dispatch('updateUser', {
        userId: id, userInput: { password }
      })
      this.editUserPasswordModal.show = false
    },
    async appendUserRole(userId, channelId, roleType) {
      await this.$store.dispatch('appendUserRole', { userId, channelId, roleType })
      this.editUserRoleModal.show = false
      this.editUserRoleModal.data.newChannelId = null
      this.editUserRoleModal.data.newRoleType = null
    },
    async removeUserRole(userId, channelId) {
      await this.$store.dispatch('removeUserRole', { userId, channelId })
      this.editUserRoleModal.show = false
    },
    async createUser({ id, name, organization, department }) {
      await this.$store.dispatch('createUser', { id, name, organization, department })
      this.createUserModal.show = false
    },
    async deleteUser(userId) {
      await this.$store.dispatch('deleteUser', { userId })
    }
  },
  filters: {
    userRoleType(value) {
      switch(value) {
        case 'guest':
          return "閲覧"
        case 'editor':
          return "編集"
        case 'director':
          return "管理"
      }
    }
  },
  computed: {
    ...mapGetters([
      'users',
      'channels'
    ])
  },
  async mounted() {
    await this.fetchAllUser()
    await this.fetchAllChannel()
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  min-height: 100%;
}

</style>
